import React from 'react'
import purchaseModalClasses from 'src/components/Modals/PurchaseModal/PurchaseModal.module.scss'
import classNames from 'classnames'
import { useIsSmallerThan } from 'src/hooks/useIsSmallerThan'
import PurchasePickedTitle from '../PurchasePickedTitle/PurchasePickedTitle'
import Confirm from 'src/components/UI/Confirm/Confirm'
import confirmClasses from 'src/components/UI/Confirm/Confirm.module.scss'
import { roundToTwo } from 'training-lane-booking-shared/utilities/functions'
import textConstants from 'training-lane-booking-shared/utilities/text'
import bundleListItemClasses from './BundleListItem.module.scss'

const BundleListItem = ({
    cart,
    itemType,
    itemData,
    handleChange,
    pendingPaymentRequestsCount
}) => {
    const isXSmall = useIsSmallerThan(480)
    const lineItem = cart?.breakdown?.find(b => b.typeId === itemType.id)

    const paddingTop = (() => {
        let padding = 0

        if (pendingPaymentRequestsCount) {
            padding += 5
        }

        return padding
    })()

    return (
        <div className={purchaseModalClasses.bundleWrapper}>
            <div
                className={classNames(
                    'grid-wrapper',
                    purchaseModalClasses.bundle
                )}>
                <div
                    className={classNames(handleChange ? 'col-5' : 'col-12', {
                        [purchaseModalClasses.pullUp]:
                            pendingPaymentRequestsCount
                    })}>
                    <PurchasePickedTitle itemType={itemType} />
                    {pendingPaymentRequestsCount ? (
                        <div className={bundleListItemClasses.pending}>
                            {pendingPaymentRequestsCount}{' '}
                            {textConstants.PRI_PENDING_PAYMENT.toLowerCase()}
                        </div>
                    ) : null}
                </div>
                {handleChange && (
                    <div
                        className="col-7 align-right"
                        style={{ paddingTop }}>
                        <Confirm
                            buttons={[
                                {
                                    insertComponent: isXSmall ? (
                                        <></>
                                    ) : (
                                        <div className="col-2" />
                                    )
                                },
                                {
                                    buttonClasses: [
                                        confirmClasses.confirmButtonProceedDanger,
                                        confirmClasses.smaller
                                    ],
                                    handleFn: () => handleChange(itemData, -1),
                                    label: '-'
                                },
                                {
                                    insertComponent: (
                                        <div
                                            className={classNames(
                                                `col-${isXSmall ? 3 : 2}`,
                                                bundleListItemClasses.number
                                            )}>
                                            {lineItem?.qty ?? 0}
                                        </div>
                                    )
                                },
                                {
                                    buttonClasses: [
                                        confirmClasses.confirmButtonProceedSafe,
                                        confirmClasses.smaller
                                    ],
                                    handleFn: () => handleChange(itemData, 1),
                                    label: '+'
                                },
                                {
                                    insertComponent: (
                                        <div
                                            className={classNames(
                                                `col-${isXSmall ? 5 : 4}`,
                                                'align-right',
                                                bundleListItemClasses.number
                                            )}>
                                            {`$${roundToTwo(
                                                lineItem?.lineTotal ?? 0
                                            ).toFixed(2)}`}
                                        </div>
                                    )
                                }
                            ]}
                        />
                    </div>
                )}
            </div>
        </div>
    )
}

export default BundleListItem
